import { navigate } from 'gatsby';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from '@4c/layout';
import { Router } from '@reach/router';

import AuthenticatedRoute from '../components/AuthenticatedRoute';
import BreadCrumbs from '../components/BreadCrumbs';
import CenterContent from '../components/CenterContent';
import Heading from '../components/Heading';
import OrderSummary from '../components/OrderSummary';
import PageRoot from '../components/PageRoot';
import PageSegment from '../components/PageSegment';
import Responsive from '../components/Responsive';
import { Elements } from '../components/Stripe';
import paths from '../paths';
import withReservation from '../utils/Reservation';
import Payment from './_payment';
import ShippingInformation from './_shipping-information';

import styles from '../styles/responsive.module.scss';

const propTypes = {};

function Checkout({ cart, location }) {
  // Shipping details are set, move to the payment screen
  if (cart.shippingAddress && location.pathname === paths.checkout) {
    navigate(paths.payment);
    return null;
  }
  return (
    <PageRoot theme="dark">
      <PageSegment theme="light">
        <BreadCrumbs active="checkout" />
        <PageSegment.Content>
          <CenterContent maxWidthLg>
            <Heading level="1" className={styles.textAlignCenterSm}>
              <FormattedMessage
                defaultMessage="Checkout"
                id="checkout.checkout.title"
              />
            </Heading>
            <Layout justify="space-between">
              <Layout grow direction="column">
                <Router>
                  <AuthenticatedRoute
                    path="/payment"
                    render={() => (
                      <Elements>
                        <Payment />
                      </Elements>
                    )}
                  />
                  <AuthenticatedRoute
                    default
                    component={ShippingInformation}
                  />
                </Router>
              </Layout>
              <Responsive lgUp>
                <OrderSummary
                  alignSelf="flex-start"
                  style={{ marginLeft: 140, width: 330 }}
                />
              </Responsive>
            </Layout>
          </CenterContent>
        </PageSegment.Content>
      </PageSegment>
    </PageRoot>
  );
}

Checkout.propTypes = propTypes;

export default withReservation(Checkout);
